import Vue from 'vue';
import { iocContainer } from '../shared/ioc/index';

Vue.use({
  install(Vue) {
    Vue.prototype.$container = iocContainer;
  },
});
